/* @format */
import store from '@/stores';
import { ClientService } from '@/scripts/services/entities/client-service';
import EventBus from '@/scripts/event-bus';

/**
 * @param {import('vue-router').Route} to
 * @param {import('vue-router').Route} from
 * @param {function} next
 */
export async function accountActivateSubscriptionGuard(to, from, next) {
    const defaultRedirectPath = '/';

    const clientId = store?.state?.context?.client?.id;
    const isClientUser = store.getters.isClientUser;
    const isAdmin = store.getters.isAdmin;

    if (!clientId || !isClientUser) {
        return next(defaultRedirectPath);
    }

    const isLegacyAccess = await ClientService.isClientLegacyAccess(clientId);
    if (!isLegacyAccess) {
        EventBus.$emit('already-activated');
        return next(defaultRedirectPath);
    }

    if (!isAdmin) {
        return next({
            name: 'AccountActivateSubscriptionContact',
        });
    }

    next();
}
